// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { FootFallDoors } from '../../../../types/geminiType';
import DraggableList, { DragHandle } from '../../../../components/DraggableList';
import { autoQuantityStr } from '../../../../utils/formatUtils';

type Props = {
  footfallData: FootFallDoors,
  footfallDataList: FootFallDoors[],
}

type State = {
  filteredDoors: string[],
}

class FootfallDoorModal extends React.Component<Props, State> {
  state: State = {
    filteredDoors: [],
  };

  hideDoor = (doorId: number) => {
    if (this.state.filteredDoors.filter(cod => cod === doorId).length > 0) {
      this.setState({ filteredDoors: this.state.filteredDoors.filter(cod => cod !== doorId) });
    } else {
      this.setState({ filteredDoors: this.state.filteredDoors.concat(doorId) });
    }
  };

  render() {
    return (
      <div className="footfall-door-modal">
        <div>
          INSERT TABLEAU
        </div>
        <div className="comparable-container">
          <Translate value="comparable.r12m" />
          <div className="comparable-line">
            <div className="base-tile">
              <div className="row-data">
                <span>{this.props.footfallData.sensorLabel}</span>
              </div>
              <div className="row-data">
                <span>{autoQuantityStr(this.props.footfallData.entrances)}</span>
              </div>
            </div>
            <div className="draggable-list-container">
              <DraggableList
                className="data-content"
                list={
                  this.props.footfallDataList
                    .filter(door =>
                      this.state.filteredDoors.filter(sensorId => sensorId === door.sensorId).length === 0)
                    .map((footfallData: FootFallDoors) => (
                      <div
                        key={footfallData.sensorId}
                        className="comparable-column"
                      >
                        <DragHandle
                          value={
                            <div>
                              <div className="row-data">
                                <span>
                                  {footfallData.sensorLabel}
                                </span>
                              </div>
                              <div className="row-data">
                                <button
                                  className="fa fa-eye"
                                  onClick={() => this.hideDoor(footfallData.sensorId)}
                                />
                              </div>
                              <div
                                className={`row-data ${this.props.footfallData.entrances && (this.props.footfallData.entrances > footfallData.entrances ? 'red' : 'green')}`}
                              >
                                <span>{autoQuantityStr(footfallData.entrances)}</span>
                              </div>
                            </div>
                          }
                        />
                      </div>
                    ))
                }
              />
              <div className="data-content">
                {
                  this.props.footfallDataList
                    .filter(door =>
                      this.state.filteredDoors.filter(sensorId => sensorId === door.sensorId).length !== 0)
                    .map((footfallData: FootFallDoors) => (
                      <div
                        key={footfallData.sensorId}
                        className="comparable-column"
                      >
                        <div>
                          <div className="row-data">
                            <span>
                              {footfallData.sensorLabel}
                            </span>
                          </div>
                          <div className="row-data">
                            <button
                              className="fa fa-eye-slash"
                              onClick={() => this.hideDoor(footfallData.sensorId)}
                            />
                          </div>
                          <div
                            className={`row-data ${this.props.footfallData.entrances && (this.props.footfallData.entrances > footfallData.entrances ? 'red' : 'green')}`}
                          >
                            <span>{autoQuantityStr(footfallData.entrances)}</span>
                          </div>
                        </div>
                      </div>
                    ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FootfallDoorModal;
